import * as React from 'react';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';
import { SkeletonLines } from '@/components/ui/skeleton';

/** Fetches `/files/:id/content` with the bearer token and shows the PDF in an iframe. */
export function PdfFileFrame({
  fileId,
  title,
  className,
}: {
  fileId: string;
  title: string;
  className?: string;
}) {
  const [url, setUrl] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    setUrl(null);
    setError(null);
    api
      .blob(`/files/${fileId}/content`)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob.type ? blob : new Blob([blob], { type: 'application/pdf' }));
        setUrl(objectUrl);
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (error) return <p className="text-sm text-destructive">Preview failed: {error}</p>;
  if (!url) return <SkeletonLines lines={2} />;
  return <PdfFrame url={url} title={title} className={className} />;
}

export function PdfFrame({ url, title, className }: { url: string; title: string; className?: string }) {
  return (
    <iframe title={title} src={url} className={cn('h-[70vh] w-full rounded-md border bg-muted', className)} />
  );
}
